/**
 * safeGoBack — replacement for history.goBack() that survives a hard refresh
 * or direct-URL/new-tab load.
 *
 * Background:
 *   react-router-dom@5 / history@4 expose history.goBack() which walks the
 *   browser's history stack. On a fresh tab or hard refresh the browser has
 *   no prior in-app entry, so goBack navigates to about:blank (or whatever
 *   was there before) — the user sees a blank page after Save.
 *
 *   history@4 only sets location.key when window.history.state.key exists
 *   (see node_modules/history/esm/history.js getDOMLocation + createLocation).
 *   On a fresh load that state is null, so location.key is undefined and we
 *   can use its absence as a reliable "no in-app entry" probe.
 *
 * Behaviour:
 *   - location.key present  → history.goBack() (normal back navigation)
 *   - location.key missing  → history.push(fallback) (deterministic landing)
 *
 * @param {object} history  react-router-dom history instance (from useHistory)
 * @param {string} fallback Path to push when there is no previous entry
 */
export const safeGoBack = (history, fallback) => {
  if (!history || typeof history.push !== "function") return;
  const hasPreviousEntry = Boolean(history.location && history.location.key);
  if (hasPreviousEntry && typeof history.goBack === "function") {
    history.goBack();
  } else {
    history.push(fallback);
  }
};
